import { queryKeys, useHttpClient } from '@repo/api-client/react';
import { UserSchema, type User } from '@repo/api-client/dtos';
import { useQuery } from '@tanstack/react-query';
import { getJSON } from '../internal/http';

type QueryEnableOptions = { enabled?: boolean };

/**
 * Read the signed-in user's profile.
 *
 * The v0.1 server only exposes `GET /v1/users/me` — there is no
 * `GET /users/:id` endpoint, by design. Cross-user reads will land
 * with the memberships expansion when we add team management.
 */
export function useUserProfile(options: QueryEnableOptions = {}) {
  const http = useHttpClient();
  const enabled = options.enabled ?? true;

  const {
    error,
    isPending: loading,
    data: profile,
  } = useQuery({
    queryKey: queryKeys.user.me(),
    queryFn: () => getJSON(http, '/users/me', UserSchema),
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  return { profile: profile as User | undefined, loading, error };
}
